<div class="verify-email">
	<h3 class="sf title">{{ 'sf.module.auth.sign_up.verify_email' | translate }}</h3>
	<span class="caption" [innerHTML]="'sf.module.auth.sign_up.confirmation' | translate: { value: usedEmail }"></span>
	<div class="resend-email-wrapper">
		<a class="link" (click)="onResendEmail()">
			<span>{{ 'sf.module.auth.sign_up.resend_email' | translate }}</span>
		</a>
	</div>
	<div class="separator"></div>
</div>
